<template>
    <el-container class="container">
        <el-header height="70px" class="index-header">

            <Head />
        </el-header>
        <el-main class="index-main">
            <Main></Main>
        </el-main>
    </el-container>
</template>

<script>
import Vue from 'vue';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI);

import Head from '../components/head.vue'
import Main from '../components/main.vue'
export default {
    name: 'indexPage',
    data() {
        return {
        }
    },
    components: {
        Head,
        Main,
    },

}
</script>

<style scoped>
.container {
    height: 100%;
    display: flex;
}

.container .index-main {
    max-width: 1200px;
    width: 100%;
    margin: 0 auto;
    padding: 20px 0px 0px 0px;
}

.container .index-header {
    background-color: #fff;
    box-shadow: 2px 3px 29px 0px rgba(214, 214, 214, 0.17);
}

.container::-webkit-scrollbar {
    display: none;
}

.index-main::-webkit-scrollbar {
    display: none;
}

@media screen and (max-width:1250px) {
    .container .index-main {
        width: 100%;
        margin: 0 auto;
        padding: 20px 0px 0px 0px;
        height: 100%;
    }

}
</style>